export default "/assets/Icon/Trophy.svg"